import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { GetGovernmentIdentifiersResponse } from './types';

export enum ListGovernmentIdentifierExtensibleFields {
  SUPPORTING_DOCUMENT = 'SUPPORTING_DOCUMENT',
}

export default function useGovernmentIdentifiers(
  businessEntityId: number,
  options?: {
    extend?: ListGovernmentIdentifierExtensibleFields[];
    /** Holds the request back where the caller has no entity to ask about yet. */
    skip?: boolean;
  }
) {
  const query = new URLSearchParams();

  if (options?.extend) query.append('extend', options.extend.join(','));

  const {
    data,
    error,
    mutate,
  }: {
    data: GetGovernmentIdentifiersResponse;
    error: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    options?.skip
      ? null
      : `business-entities/${businessEntityId}/government-identifiers?${query.toString()}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
